import ga from "./analytics";
import PropTypes from "prop-types";
import React from "react";

const Email = ({ classes, email, showPrefix }) => {
  return (
    <span className={classes}>
      <a
        href={"mailto:" + email}
        onClick={() => ga.event("Agent-Interaction", "Email", email)}
      >
        {showPrefix ? <span className="prefix">Email: </span> : null}
        {email.toLowerCase()}
      </a>
    </span>
  );
};

Email.propTypes = {
  classes: PropTypes.string,
  email: PropTypes.string.isRequired,
  showPrefix: PropTypes.bool,
};

Email.defaultProps = {
  showPrefix: true,
};

export default Email;



// WEBPACK FOOTER //
// ./src/components/shared/email.js